import { Images } from "../../Images";
import { Settings } from "../../Settings";
import Totals from "../crew/Totals";
import BigNum from "../math/BigNum";
import GameTime from "../time/GameTime";
import NumberValue from "../value/NumberValue";
import Bonus from "./Bonus";
import BonusCreator from "./BonusCreator";
import NumberValueBonus from "./NumberValueBonus";

export default class UpgradeBonusCreator extends BonusCreator {
    /**
     * @param {string} id 
     * @param {GameTime} gameTime
     * @param {Totals} totals
     * @param {NumberValue} numberValue
     */
    constructor(id, gameTime, totals, numberValue) {
        super(id, gameTime, totals);
        /**
         * @constant
         * @type {NumberValue}
         */
        this.numberValue = numberValue;

        /**
         * @constant
         * @type {BigNum}
         */
        this.cost = new BigNum(Settings.bonus.activationCost);
    }

    /**
     * @override
     * @returns {Bonus}
     */
    createBonus() {
        const activeValue = 10;

        return this.createBonusInternal(activeValue);
    }

    /**
     * @override
     * @param {number} activationValue
     * @returns {Bonus}
     */
    createBonusFromSave(activationValue) {
        return this.createBonusInternal(activationValue);
    }

    /**
     * @private
     * @param {number} activationValue 
     * @returns {Bonus}
     */
    createBonusInternal(activationValue) {
        const activationTurns = Settings.bonus.activationTurns;

        return new NumberValueBonus(this.id, 'Upgrade Multiplier', 'Upgrades x' + activationValue, 
            Images.currency.upgrades, this.gameTime, this.totals, this.cost,
            activationTurns, this.numberValue, activationValue
        );
    }
}